import { render, staticRenderFns } from "./SaveSearchModal.vue?vue&type=template&id=12c0aee2&scoped=true&"
import script from "./SaveSearchModal.vue?vue&type=script&lang=js&"
export * from "./SaveSearchModal.vue?vue&type=script&lang=js&"
import style0 from "./SaveSearchModal.vue?vue&type=style&index=0&id=12c0aee2&prod&lang=scss&scoped=true&"
import style1 from "./SaveSearchModal.vue?vue&type=style&index=1&id=12c0aee2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c0aee2",
  null
  
)

export default component.exports